import { Dimensions, Platform } from 'react-native'

export const isIOS = Platform.OS === 'ios'
export const isAndroid = Platform.OS === 'android'
export const isWeb = Platform.OS === 'web'
export const isNative = isIOS || isAndroid
export const isSmallPhone = isIOS && Dimensions.get('window').width <= 380
